import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import { CleanFilesStoreAction, FilesAddAction, FilesDeleteAction, FilesUpdateAction } from '../actions/files.action';
import { FilesState } from '../files.state';

const initialState: FilesState = {
  filesDictionary: {},
};

export const filesActionReducer = createReducer(
  initialState,
  on(FilesAddAction, (state, { id, files }) => {
    const value = structuredClone(state.filesDictionary);
    if (!value[id]) {
      value[id] = [];
    }
    value[id] = [...value[id], ...files].filter((v, i, a) => a.findIndex(x => x.id === v.id) === i);
    const res = {
      filesDictionary: value,
    };
    return res;
  }),
  on(FilesDeleteAction, (state, { itemId, fileId }) => {
    const value = structuredClone(state.filesDictionary);
    _.remove(value[itemId], a => a.id === fileId);
    const res = {
      filesDictionary: value,
    };
    return res;
  }),
  on(FilesUpdateAction, (state, { id, file }) => {
    const value = structuredClone(state.filesDictionary);
    const index = value[id].findIndex(a => a.id === file.id);
    value[id][index] = file;
    const res = {
      filesDictionary: value,
    };
    return res;
  }),
  on(CleanFilesStoreAction, (state): { filesDictionary: any } => ({
    filesDictionary: {},
  })),
);
